import CommonContainer from "../Container/CommonContainer"
import { AddMultipleDocuments } from "../../Services/Document/DocumentService"
import { useEffect, useRef, useState } from "react";
import { FileIcons, allowedTypes } from "../../Common/CommonVariables";
import toast from "react-hot-toast";
import { FaCloudUploadAlt } from "react-icons/fa";

const DocumentUploadComponent = () => {
    const fileInputRef = useRef(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const maxFiles = 5;
    const [loading, setLoading] = useState(false);
    const [UploadedFileAttachmentList, setUploadedFileAttachmentList] = useState([]);
    const uploadedTitles = UploadedFileAttachmentList.map(file => file.Title);
    const [fetchedURLs, setFetchedURLs] = useState([]);

    const handleFileChange = (event) => {

        const file = event.target.files;
        const maxFileSize = 5 * 1024 * 1024; // 5MB

        if (!file || file.length === 0) {
            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }
            return;
        }

        if (selectedFiles.length >= maxFiles) {
            toast.error(`You can only upload up to ${maxFiles} files.`);
            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }
            return;
        }

        if (!allowedTypes.includes(file[0].type) || file[0].size > maxFileSize) {
            toast.error('File is either unsupported or exceeds the 5MB limit.');
            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }
            return;
        }

        //debugger;
        const alreadyExists = selectedFiles.some(f => f.name === file[0].name && f.size === file[0].size);
        if (alreadyExists) {
            toast.error('This file is already selected.');
            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }
            return;
        }
        const filesArray = Array.from(event.target.files);
        setSelectedFiles(prevFiles => [...prevFiles, ...filesArray]);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const handleFileUpload = () => {
        //debugger;
        setLoading(true);
        const formData = new FormData();


        const uploadedTitles = UploadedFileAttachmentList.map(file => file.Title);
        const newFilesToPush = selectedFiles.filter(file => !uploadedTitles.includes(file.name));

        newFilesToPush.forEach(file => {
            formData.append('files', file)
        });

        if (newFilesToPush.length <= 0) {
            toast.error("Please select file first!")
            setLoading(false);
            return
        }
        AddMultipleDocuments(formData)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    if (fileInputRef.current) {
                        fileInputRef.current.value = null;
                    }
                    // setUploadedFileAttachmentList(data.Data);
                    setUploadedFileAttachmentList(prevList => [...prevList, ...data.Data]);
                    setFetchedURLs(data.Data)
                    handleRemoveSelectedUploadedFiles();
                    toast.success(data.Data.length + " files uploaded successfully.")
                } else {
                    // setUploadedFileAttachmentList([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setLoading(false));
    };

    const handleRemoveSelectedUploadedFiles = () => {
        //debugger;
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        setSelectedFiles([])
        setUploadedFileAttachmentList([])
    }

    useEffect(() =>{
        
    })

    return (
        <CommonContainer icon={<FaCloudUploadAlt size={20}/>} heading="Document Upload">
            <div>
                <div className="d-flex align-items-center gap-2 mb-2 pl-3" style={{ fontSize: "13px" }} >
                    <label className="fw-bold mb-0-5">Upload Attachments :</label>
                    <input className="form-control" style={{ width: '250px' }} type="file"
                        ref={fileInputRef}
                        accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.webp,.bmp,.svg,.eml"
                        onChange={handleFileChange}
                    />
                    <button className="btn btn-success" disabled={loading} type="button" onClick={handleFileUpload}> Upload </button>
                    {selectedFiles && selectedFiles.length > 0 && (
                        <button className="btn btn-danger" disabled={loading} type="button" onClick={handleRemoveSelectedUploadedFiles}> Remove </button>
                    )}
                    <div className="alert alert-info p-2 mt-1 pt-2" style={{ fontSize: '9px', maxWidth: '350px', marginBottom: '4px' }}>
                        <strong>Note:</strong> You can upload a maximum of 5 files(less than 5MB).<br />
                        Accepted file: <code>.pdf</code>, <code>.doc</code>, <code>.docx</code>, <code>.jpeg</code>, <code>.jpg</code>, <code>.png</code>, <code>.gif</code>, <code>.webp</code>, <code>.bmp</code>, <code>.svg</code>, <code>.eml</code>
                    </div>
                </div>

                <ul className="list-group pl-3 pb-2 pt-1 col-md-6" >
                    {selectedFiles && selectedFiles.length > 0 ? (
                        selectedFiles.map((file) => (
                            <li key={file.ContentDocumentId} className="list-group-item d-flex align-items-center" >
                                {FileIcons[file.name.split('.').pop()] || FileIcons.other}
                                &nbsp;{file.name}
                            </li>
                        ))
                    ) : (
                        <p> No attachments available... </p>
                    )}
                </ul>
            </div>
            
            {/* Only show table if fetchedURLs has data */}
            {fetchedURLs.length > 0 && (
                <div className="table-responsive mt-2" style={{ overflowY: "auto", maxHeight: "680px" }}>
                    <table className="table table-bordered custom-table">
                        <thead>
                        <tr>
                            <th style={{width: '20%'}}>File Name</th>
                            <th style={{width: '70%'}}>URL</th>
                            <th style={{width: '10%'}}>Status</th>
                        </tr>
                        </thead>
                        <tbody style={{fontSize:"10px"}}>
                            {fetchedURLs.map((rec, index) => (
                                <tr key={index}>
                                    <td>{rec.FileName}</td>
                                    <td><a href={rec.Url} target="_blank">{rec.Url}</a></td>
                                    <td>{rec.Status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </CommonContainer>
    )
}

export default DocumentUploadComponent